<template>
  <v-container class="fill-height justify-center">
    <v-app-bar color="#fff" fixed nav elevation="0" app>
      <v-spacer></v-spacer>
      <div>
        <div class="caption text-right">{{ user.userName }}</div>
        <div class="caption text-right">{{ user.userEmail }}</div>
      </div>
      <v-menu
        close-on-content-click
        max-width="350"
        :nudge-bottom="10"
        offset-y
        rounded="lg"
        max-height="450"
        allow-overflow
      >
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn icon v-on="{ ...onMenu, ...onTooltip }" class="mx-1">
                <v-avatar>
                  <v-img
                    :src="require('@/assets/icon/toko.png')"
                  ></v-img>
                </v-avatar>
              </v-btn>
            </template>
            <div class="caption font-weight-bold">Akun POS</div>
            <div class="caption">{{ user.name }}</div>
            <div class="caption">{{ user.company_name }}</div>
          </v-tooltip>
        </template>

        <v-card width="350">
          <v-card-text class="text-center">
            <v-avatar size="80">
              <v-img
                :src="
                require('@/assets/icon/toko.png')
                "
              ></v-img>
            </v-avatar>
            <div class="mt-4 subtitle-1">{{ user.name }}</div>
            <div class="mb-4 caption">{{ user.company_name }}</div>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              class="mb-4 text-none"
              depressed
              outlined
              color="#240087"
              @click="logout"
              >Keluar dari aplikasi</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          <v-row class="justify-space-between align-center">
            <v-col cols="12" md="2" v-for="(item, index) in user.outlet_arr" :key="index">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" style="border-radius: 16px; border: 2px solid #EBEBEB; border-style: dashed;" @click="todashboard(item)" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center pb-0">
                    <v-avatar size="128">
                      <v-img :src="require('@/assets/icon/store_amanata.png')"></v-img>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2"> {{ item.outlet_name }} </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/ake/music'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="#D400B8">mdi-cellphone</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    AKE
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  name: "indexApp",
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    fcm() {
      return this.$store.state.fcm;
    },
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },

    todashboard(item) {
      TokenService.saveOutlet(
        JSON.stringify(item)
      )

      this.$store.commit("setOutlet", item)
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style>
</style>